import { onMounted, watch } from "vue"

export function useScrollToTop(...sources: any[]) {
  onMounted(() => {
    sources.forEach(source => {
      watch(source, () => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      })
    })
  })
}
